module.exports = __webpack_public_path__ + "static/media/cl_trade_arrow_red.a3a7b46b.svg";